import { CountryIconProps } from './types';

const VG = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3582)">
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z"
        fill="#0052B4"
      />
      <path
        d="M11.9688 12.0007H12.0009C12.0009 11.9899 12.0009 11.9794 12.0009 11.9686C11.9902 11.9793 11.9795 11.99 11.9688 12.0007Z"
        fill="#F0F0F0"
      />
      <path
        d="M12 6.26178C12 4.15029 12 2.76677 12 0.000915527H11.998C5.37145 0.00204053 0 5.37415 0 12.0009H6.26086V8.4754L9.78637 12.0009H11.9679C11.9786 11.9902 11.9893 11.9795 12 11.9688C12 11.1604 12 10.439 12 9.78738L8.47443 6.26178H12Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.07027 1.56415C4.19344 2.63285 2.63311 4.19313 1.56445 6.06996V11.9989H4.69491V4.6947V4.6946H11.9993C11.9993 3.70727 11.9993 2.76668 11.9993 1.56415H6.07027Z"
        fill="#D80027"
      />
      <path
        d="M17.218 11.9996L13.9746 15.2431C14.5825 16.4154 15.8063 17.217 17.218 17.217C18.6298 17.217 19.8536 16.4154 20.4615 15.2431L17.218 11.9996Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9999 10.5244L7.73637 6.26099H6.26074V6.26108L11.9998 12.0001H11.9999C11.9999 12.0001 11.9999 10.9826 11.9999 10.5244Z"
        fill="#D80027"
      />
      <path
        d="M13.5654 6.26099V12.0001V12.0001C13.5655 14.7957 17.2176 15.6523 17.2176 15.6523C17.2176 15.6523 20.8697 14.7957 20.8698 12.0001V12.0001V6.26099H13.5654Z"
        fill="#6DA544"
      />
      <path
        d="M17.9998 8.86987H16.4346V13.0438H17.9998V8.86987Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.2172 9.65174C17.6494 9.65174 17.9998 9.30135 17.9998 8.86911C17.9998 8.43688 17.6494 8.08649 17.2172 8.08649C16.785 8.08649 16.4346 8.43688 16.4346 8.86911C16.4346 9.30135 16.785 9.65174 17.2172 9.65174Z"
        fill="#A2001D"
      />
      <path
        d="M15.6529 7.30481H14.6094V8.34829H15.6529V7.30481Z"
        fill="#FFDA44"
      />
      <path
        d="M15.6519 9.65198H14.6084V10.6955H15.6519V9.65198Z"
        fill="#FFDA44"
      />
      <path
        d="M15.6519 12.0005H14.6084V13.044H15.6519V12.0005Z"
        fill="#FFDA44"
      />
      <path
        d="M19.8257 7.30548H18.7822V8.34897H19.8257V7.30548Z"
        fill="#FFDA44"
      />
      <path
        d="M19.8257 9.65198H18.7822V10.6955H19.8257V9.65198Z"
        fill="#FFDA44"
      />
      <path
        d="M19.8257 12.0005H18.7822V13.044H19.8257V12.0005Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3582">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default VG;
